export default {
  "Modal": {
    "CloseModal": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开店前"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服务机运营已截止\n想要订购的话请咨询柜台。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认自助服务机运营时间后使用。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服务机运营时间"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上午"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下午"])}
    },
    "HealthyCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查中"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目前无法在自助服务机进行订单"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请咨询柜台的合伙人。"])}
    },
    "Helper": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帮助功能"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["很难使用自助服务机吗？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可使用以下功能。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您可以随时关闭该功能。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["轮椅模式"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个子矮或者坐在轮椅上也可以使用。"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["高对比度模式"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["提供帮助视觉不便者的黑白高对比画面。"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["职员呼叫"])}
    },
    "EMoneySelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子卡余额确认"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择要确认余额的电子货币。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "EMoneyCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子卡余额确认"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将支付二维码放在条形码阅读器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果无法识别二维码，请亮屏。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["余额"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
    },
    "EMoneyReady": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查电子货币余额"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["将 Pay 的二维码放在条形码阅读器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二维码无法读取时点亮屏幕。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["余额"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
    },
    "StaffCall": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["职员呼叫"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要叫店员吗？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫后请稍等"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫了职员。 请稍等。"])}
    },
    "MenuPersonal": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过敏/营养信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数量"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要加餐吗？"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["期权金额"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订货金额"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["装进购物车"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过敏成分"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["该食品与使用右侧标示成分的产品在同一制造设施中制造。"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营养成分"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["热量\n(kcal)"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["蛋白质\n(g)"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["脂肪\n(g)"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["碳水化合物\n(g)"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["糖分\n(g)"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["反式脂肪\n(g)"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["盐分\n(mg)"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["咖啡因\n(mg)"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["胆甾醇\n(mg)"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["副菜单"])}
    },
    "OrderSelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择订购方法。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在店内食用时，请将'店内'带回去时，请点击'外卖'。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果选择外卖的话，不能在店里吃。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店內"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外卖"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "MenuEvent": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["推荐菜单"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一起吃会更好"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择商品后，请点击'放入购物车'按钮。（可重复）"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["追加金额"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没事。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加"])}
    },
    "Members": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员认证"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请把要结算的会员条形码放在条形码阅读器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请尽量把手机的亮度调亮"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机优惠券"])}
    },
    "MembershipMaster": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員認證"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請用手機號碼或條碼/QR碼進行認證"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機號碼"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["條形碼/QR碼"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只輸入手機號碼而不輸入「-」"])},
      "MSG6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入"])},
      "MSG7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繼續"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除\n全部"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你是客戶嗎？"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果正確，請繼續"])}
    },
    "MembershipPw": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員密碼認證"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入密碼"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密碼"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入密碼"])}
    },
    "MembersInfo": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认您的积分。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客户名"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等级"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积累"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "Point": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用积分"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分可从1000P开始使用。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用的积分不能退款。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算总金额"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用积分"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入使用积分"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用积分"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "Card": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡结算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将卡插入卡口或靠近手机"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请参考以下图片进行。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IC卡结算时"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机支付结算时"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["读卡器"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将卡一直插入插入口，等到结算完毕为止。"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将手机放在读卡器上,等到结算完毕为止。"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "CardReturn": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卡回收"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请把卡收回来"])}
    },
    "Barcode": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二维码结算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将二维码放在条形码阅读器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请尽量把手机的亮度调亮"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "CashRecipt": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["现金收据"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请准确输入个人及事业者认证信息。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您输入的信息不另行认证。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只输入手机号码而不输入'-'"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个人"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营业者"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全删除"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意个人信息收集使用同意书及个人信息提供及委托同意书"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["现金收据的发行"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营业执照号"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["仅输入营业执照号而不输入 -"])}
    },
    "Alert": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分累积了。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
    },
    "AlertHome": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您要取消订购后第一次回去吗？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["购物车内的商品将被删除。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有 kiosk 操作\n返回到第一个屏幕"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请轻触按钮继续使用"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["剩余时间"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["继续使用"])}
    },
    "AdminLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服务机管理器登录"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请标记电子钥匙或输入密码。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户名"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全删除"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
    },
    "PaymentFail": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款失败"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算失败。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请咨询柜台。"])}
    },
    "PaymentError": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款错误"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算失败。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请咨询柜台。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "BasketDel": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全删除"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确定要删除购物车里的所有商品吗？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["空了菜篮子就回不来了"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Cash": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["现金结算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请把现金投入下面。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请务必确认要返还的零钱。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小计金额"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["投入金额"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["零钱"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭"])}
    },
    "Emoney": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用电子货币支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择电子货币。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交通系统IC"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["乐天Edy"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "EmoneyPay": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用交通系统IC支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请把电子货币靠近读卡器。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "PayComplete": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算完毕"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款已正常处理。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["￥"])}
    },
    "QrCode": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用电子货币支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择电子货币。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["梅尔菲"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["乐天Pay"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二维码结算"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alipay"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WeChat Pay"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PayPay"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LINE Pay"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["au Pay"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QUOPay"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yucho Pay"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naver Pay"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kakao Pay"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SSG Pay"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smile Pay"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zero pay"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L.PAY"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PAYCO"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Card"])}
    },
    "QrCodePay": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二维码结算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请把二维码靠近条形码阅读器。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["把手机屏幕调亮就容易阅读了。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Sco": {
      "Basket": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册无条形码商品"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择您想要购买的\n 商品。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入购买数量。"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除全部"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消除"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["追加金额"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["之前"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
        "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数量"])}
      },
      "Barcode": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册无条形码商品"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["想要购买的商品的条形码一列编号"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["条形码"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入条形码序列号"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除全部"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消除"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])}
      }
    },
    "Allergy": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食物过敏列表"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认想要排除的"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["适用"])}
    },
    "Sign": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子签名"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请签名后按确认按钮。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["签名后点击签名完成按钮才能完成结算。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请在这里签名"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算金额"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["签名完成"])}
    },
    "Membership": {
      "Point": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用会员积分"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員積分最少"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扣除的积分不能退款"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算总金额"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用积分"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入使用点"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用结算总金额积分"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除全部"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])},
        "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用会员积分"])},
        "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["P开始使用。"])},
        "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員積分單位"])},
        "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員積分"])},
        "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可以以P爲單位使用。"])},
        "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1次可用限度"])},
        "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是P."])},
        "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用了比結算金額更多的積分。"])},
        "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確定要使用嗎 ?"])},
        "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可使用一次的限度積分"])}
      },
      "Check": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员积分信息"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认会员积分信息。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客户名"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等级"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我只会积分"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用和累积积分"])}
      }
    },
    "Instalment": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择付款方式"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择一次性付款和分期付款时间"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分期付款手续费、免息优惠等根据信用卡公司的政策而有所不同。 \n请咨询相关信用卡公司。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择分期付款"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 月"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一次性付款"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Coupon": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机优惠券信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择您想要使用的手机优惠券。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算总金额"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打折"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用手机优惠券"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒關係，按一下按鈕繼續下一步"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帶優惠券的產品信息"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇要使用優惠券的產品"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兌換券"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["優惠券"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["優惠券條件不符合，不能使用"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有優惠券"])}
    },
    "AlertConfirm": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代幣到期需要重新啓動應用程序"])}
    },
    "AlertSuccess": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购失败"])}
    },
    "Payment": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款信息傳輸正在處理中。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在完成交易。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退货/强制取消 正在处理取消结算"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在处理信用卡取消。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在进行结算取消中。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在发送付款信息"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在处理完成中"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未完成的付款信息正在處理中。"])}
    },
    "AlramConfirm": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知发送失败 \n请咨询职员"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["振动铃传输失败 。 \n请咨询职员"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跳过"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重试"])}
    }
  },
  "User": {
    "Idle": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您好！请选择订购方法。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店内"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外卖"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["移动订购"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日本語"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국어"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ENGLISH"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繁体中文"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["简体中文"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子卡余额查询"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["职员呼叫"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帮助功能"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["入门"])}
    },
    "Order": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新产品"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折价"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["人气"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["促销活动"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["推荐"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["布景"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["含有过敏成分"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卖完"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["职员呼叫"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帮助功能"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查过敏成分"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请勾选想要排除的项目"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["购物篮"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除全部"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合计"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点菜"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售中"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出管理员模式"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过敏成分\n 过滤器"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品数量"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单金额"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品数量"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开购物车"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭购物车"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自愿登记"])},
      "msg29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手工制品"])},
      "msg30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["任意登记中。\n请稍等"])},
      "msg31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手游产品中。\n请稍等"])},
      "msg32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按国家查看葡萄酒"])},
      "msg33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择您要查询的产地"])},
      "msg34": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NewZealand"])},
      "msg35": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Germany"])},
      "msg36": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["USA"])},
      "msg37": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spain"])},
      "msg38": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italy"])},
      "msg39": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chile"])},
      "msg40": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Portugal"])},
      "msg41": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France"])},
      "msg42": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Australia"])},
      "msg43": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Argentina"])},
      "msg44": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["处理完成"])}
    },
    "OrderCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购明细确认"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分/折扣"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择付款方式"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择通知"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购方法"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店内"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外卖"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购明细"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认您订购的商品。"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可通过下面的箭头按钮滚动列表。"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数量"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["税率"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购数量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金额"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金额"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应付款额"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])}
    },
    "OrderSaving": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分/折扣"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择积分及打折手段。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可重复积分/折扣"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中國海會會員"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存图章"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用优惠券"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购数量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金额"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金额"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应付款额"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])}
    },
    "PaySelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择付款方式"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择要进行结算方式。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算只能用一种手段进行。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["现款"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子卡"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付(Pay)"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优惠券"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机商品劵"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子货币余额确认"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购数量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金额"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金额"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应付款额"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["银联卡"])}
    },
    "BellSelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择通知"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择要接收指导的通知服务。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可以在通知和呼叫铃中选择。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["菜单准备就绪后，\n你会收到通知对话。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["准备好菜单后，\n会通过震动铃通知您。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知谈话"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["震动铃通知"])}
    },
    "BellMobile": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入通知通话信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请准确输入通知发送的手机号码。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您输入的号码不另行认证。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只输入手机号码而不输入'-'"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入完成"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全删除"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意个人信息收集使用同意书及个人信息提供及委托同意书"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入振动铃信息"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请正确输入震动铃号码"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["购买的产品信息将发送到 Notification Talk"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入您的手机号码，享受各种福利"])}
    },
    "MobileFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单已完成！"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知通话准备就绪"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["菜单准备好后我们会通过通知通知您。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收据输出"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确定要打印收据吗?"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收据"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不打印"])}
    },
    "PagerFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单已完成！"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["振动铃准备完毕"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["准备好菜单后 用震动铃告诉大家"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收据输出"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确定要打印收据吗？"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收据"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不打印"])}
    },
    "AdultCertification": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人认证"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["由于未成年人不能购买本产品，因此需要成人身份验证。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["勾选下面的认证方式后, 准备好认证方式, 点击Authenticate按钮。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用 Kakao 进行身份验证"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用 PASS 进行身份验证"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["识别条形码或二维码"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["让你的手机屏幕亮度尽可能高"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人认证完成"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人身份验证完成\n请继续付款"])}
    },
    "WineFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单完成"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您的葡萄酒订单已完成"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品酒师"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["准备产品发布"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自动售货机正在准备酒\n请稍候"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["产品正在被移除"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开自动售货机门取出酒"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["产品出口完成"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请关闭自动售货机门"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["葡萄酒销售完成\n请取回您的信用卡"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["准备分酒"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品酒机正在准备葡萄酒\n请稍等"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["配酒"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请按下品尝器上的按钮"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["酒分配完成"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["出口机"])},
      "msg98": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重试"])},
      "msg99": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AlimTalk传输和收据打印"])}
    },
    "Pickup": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择验证手段"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认订购内容"])},
      "PickupSelect": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认接货订购"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请进行认证确认订购明细。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用QR码进行认证"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入订购号"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupQRCode": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用QR码进行认证"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将手机应用程序上的二维码放在阅读器上。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请尽量把手机画面调亮。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupMobile": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入订购号"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入手机应用程序上的订购号。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您输入的号码不另行认证。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购号码"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入订购号"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意个人信息收集使用同意书及个人信息提供及委托同意书"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入完成"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全删除"])}
      },
      "PickupCheck": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购认证成功"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认订购内容。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开始准备菜单了"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购号码"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卖场名称"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接收时间"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["总金额"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购明细正确。"])}
      },
      "PickupCheckError": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订购确认失败"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请确认认证失败的原因"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有进行事前结算。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请在订单上的卖场取货。"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupFinish": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认完毕！"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请在柜台领取商品。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要准备商品的时间/n准备完毕后,我会叫您的订购号码。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["秒后首先返回画面。"])}
      }
    },
    "Sco": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开机"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["税率"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数量"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品未扫描"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入条形码"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单数量"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["订单金额"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金额"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合计金额"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待售物品"])}
    },
    "HelperHeight": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初始化"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上传屏幕"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卸载屏幕"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按下按钮，屏幕就可以上下移动了"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结束模式"])}
    },
    "Membership": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員應用失敗。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 返回上一階段 。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您要積分嗎？"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分使用已完成\n\r 請進行剩餘金額的結算"])}
    }
  },
  "Admin": {
    "Common": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发生错误。 请咨询管理员。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已保存。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["它已被处理。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请在管理页面上解决。"])}
    },
    "AdminHeader": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin Setting"])},
      "menu1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主要"])},
      "menu2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端管理"])},
      "menu3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售管理"])},
      "menu1_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主页"])},
      "menu2_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端信息"])},
      "menu2_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端设置"])},
      "menu2_3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端监控"])},
      "menu3_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算明细"])},
      "menu3_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售情况"])}
    },
    "AdminFooter": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理员退出"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["切换用户"])}
    },
    "AdminLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin Login"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator ID"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter login ID"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter a password"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please check employee information"])}
    },
    "CashierLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收银台登录"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自动登录"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收银员ID"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择ID。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入密码。"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登录"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除所有"])}
    },
    "KioskAuth": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Device list"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk NO."])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk ID"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk Name"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticate Progress"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verified"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unauthorized"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticate"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Would you like to authenticate with"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If you want authenticate a device other than the selected device, you need to reinstall the program."])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verification"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company CD"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tnant CD"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop ID"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop Name"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pos No"])}
    },
    "AdminHome": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主屏幕"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开状态"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保留状态"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速启动"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端监控"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算明细"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端信息"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开/关闭"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端设置"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在关闭/结算"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入储备"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关门"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入准备金"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数量"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合计"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["储存"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["圆"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品信息确认"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取款"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在检查"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查窗口"])},
      "msg29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开放进度"])},
      "msg30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开"])},
      "msg31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭/结算"])},
      "msg32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在维护期间激活弹出窗口。"])},
      "msg33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在维护期间关闭弹出窗口。"])},
      "msg34": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开放进度"])}
    },
    "KioskInfo": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["区分"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设定值"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证信息"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输出信息"])}
    },
    "KioskSetting": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端设置"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["区分"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设定值"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设定"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初始化"])}
    },
    "KioskMonitoring": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端监控"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["终端资源"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["类型"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网络"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中央处理器"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内存"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["硬盘"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新启动PC"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新启动App"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["调整日期"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新启动"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接口联动状态"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查状态"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联动设备状态/控制"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最后状态消息"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新启动了。"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App结尾"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结尾"])}
    },
    "SalesList": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结算明细"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售情况"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["整体"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["普通的"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查询期间"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上周"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["这周"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上个月"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本月"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["三个月"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["现款"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其他"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索结果"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易时间"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易编号"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["总额"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["批准与否"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數據不存在。"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["強制取消"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重印收據"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请检查打印的收据。"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易方式"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收據"])}
    },
    "SalesReceipt": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售现状"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营业日期"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查询"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销售摘要"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收据"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["得到通知"])}
    }
  }
}